import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { LongHaulRequestFormulateDecision, LongHaulRequestOption, LongHaulRequestOptionFormulatedDecision, LongHaulRequestConfirmShipPassing } from 'src/app/shared/models/long-haul.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Router } from '@angular/router';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-confirm-ship-passing',
  templateUrl: './confirm-ship-passing.component.html'
})

export class ConfirmShipPassingComponent implements OnInit {
  //#region Properties & Variables
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  public isRequestSucceeded: boolean = false;
  //Options
  private isPassingdateSeventy : boolean = false;
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  private getRequestOptionsDetailsRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private getRequestOptionsDetailsRequestResponseObject: ResponseObject = new ResponseObject();
  private getRequestOptionsDetailsResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private selectedLongHaulRequestRequestorDecisionOption: LongHaulRequestOptionFormulatedDecision = new LongHaulRequestOptionFormulatedDecision();
  private isOptionDetailsEnabled: boolean = false;
  //Passing Date
  private passingDateMaxDate: Date = new Date(Date.now());
  //Submit
  private confirmShipPassingRequest: LongHaulRequestConfirmShipPassing = new LongHaulRequestConfirmShipPassing();
  private confirmShipPassingRequestResponseObject: ResponseObject = new ResponseObject();
  private isFormSubmitted: boolean = false;
  private isOptionSelectionNotValid: boolean = false;
  private isPassingDateNotValid: boolean = false;
  //Loading Components
  private noOfLoadedComponents: number = 0;
  private noOfComponentsToLoad: number = 2;
  //Form Mode
  private formMode: FormMode = FormMode.New;
  private getConfirmShipPassingObjectResponseObject: ResponseObject = new ResponseObject();
  //User Properties
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private longHaulService: LongHaulService,public datepipe: DatePipe, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.longHaulRequestOptions = this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.loadComponents();
    }
  }
  loadComponents(): void {
    this.getRebateRequestOptions();
    this.getConfirmShipPassingObject();
  }
  getRebateRequestOptions(): void {
    this.getRequestOptionsDetailsRequest.LongHaulRequestId = this.rebateRequestId;
    for(let i: number = 0; i < this.longHaulRequestOptions.length; i++){
      this.getRequestOptionsDetailsRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
      this.getRequestOptionsDetailsRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.longHaulRequestOptions[i].Id;
    }
    this.getRebateRequestRequestorDecision();
  }
  getRebateRequestRequestorDecision(): void {


    this.getRequestOptionsDetailsRequest.IsFormulatedDecisionComponent = true;
    this.longHaulService.getRebateRequestToFormulateDecision(this.getRequestOptionsDetailsRequest).subscribe(
      data => this.getRequestOptionsDetailsRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestRequestorDecisionCompleted()
    );
  }
  getRebateRequestRequestorDecisionCompleted(): void {


    if(this.getRequestOptionsDetailsRequestResponseObject.Success) {
      this.getRequestOptionsDetailsResponse = this.getRequestOptionsDetailsRequestResponseObject.Data as LongHaulRequestFormulateDecision;
      this.checkLoadedComponents();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  getConfirmShipPassingObject(): void {


    this.longHaulService.getConfirmShipPassing(this.rebateRequestId).subscribe(
      data => this.getConfirmShipPassingObjectResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getConfirmShipPassingObjectCompleted()
    );
  }
  getConfirmShipPassingObjectCompleted(): void {
    if(this.getConfirmShipPassingObjectResponseObject.Success) {
      this.confirmShipPassingRequest = this.getConfirmShipPassingObjectResponseObject.Data as LongHaulRequestConfirmShipPassing;
      this.checkLoadedComponents();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  onOptionSelect(index: number){
    this.isOptionDetailsEnabled = true;
    this.selectedLongHaulRequestRequestorDecisionOption = this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision[index];
    this.confirmShipPassingRequest.GrantedRebatePercentage = +this.selectedLongHaulRequestRequestorDecisionOption.RebatePercentage;
    this.isOptionSelectionNotValid = false;
  }
  onShipPassedChange(): void {
    this.confirmShipPassingRequest.IsShipPassed = JSON.parse(this.confirmShipPassingRequest.IsShipPassedString);
    this.isOptionSelectionNotValid = false;
    this.isPassingDateNotValid = false;
  }
  onPassingDateChange(): void {

  /*  let passingDate = this.datepipe.transform(this.confirmShipPassingRequest.PassingDate,'dd-MM-yyyy');
    let rebateDate = this.getRequestOptionsDetailsResponse.ModifiedDate;*/

    let passingDate = this.confirmShipPassingRequest.PassingDate;
    let rebateDate =  new Date(this.getRequestOptionsDetailsResponse.ModifiedDate);

    var diff = Math.abs(passingDate.getTime() - rebateDate.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
     if (diffDays > 70){
       this.isPassingdateSeventy = true;
     }
     else
     {
       this.isPassingdateSeventy = false;
     }

    //if(this.confirmShipPassingRequest.PassingDate === "" || this.confirmShipPassingRequest.PassingDate === undefined)
    if(this.confirmShipPassingRequest.PassingDate === undefined)
      this.isPassingDateNotValid = true;
    else
      this.isPassingDateNotValid = false;
  }
  submit(): void {
    let isFormValid: boolean = true;
    //Check Form Validity
    //[01] Ship Passed
    if(this.confirmShipPassingRequest.IsShipPassed){
      //[01] Actual Voyage Option  ++ [02] Paasing Date
      //if((this.confirmShipPassingRequest.LongHaulRequestOptionId === "" || this.confirmShipPassingRequest.LongHaulRequestOptionId === undefined || this.confirmShipPassingRequest.LongHaulRequestOptionId === "00000000-0000-0000-0000-000000000000") && (this.confirmShipPassingRequest.PassingDate === "" || this.confirmShipPassingRequest.PassingDate === undefined || this.confirmShipPassingRequest.PassingDate === null)){
      if((this.confirmShipPassingRequest.LongHaulRequestOptionId === "" || this.confirmShipPassingRequest.LongHaulRequestOptionId === undefined || this.confirmShipPassingRequest.LongHaulRequestOptionId === "00000000-0000-0000-0000-000000000000") && (this.confirmShipPassingRequest.PassingDate === undefined || this.confirmShipPassingRequest.PassingDate === null)){
        this.isOptionSelectionNotValid = true;
        this.isPassingDateNotValid = true;
        isFormValid = false;
      }
      //[01] Actual Voyage Option
      else if(this.confirmShipPassingRequest.LongHaulRequestOptionId === "" || this.confirmShipPassingRequest.LongHaulRequestOptionId === undefined || this.confirmShipPassingRequest.LongHaulRequestOptionId === "00000000-0000-0000-0000-000000000000"){
        this.isOptionSelectionNotValid = true;
        isFormValid = false;
      }
      //[02] Paasing Date
      //else if(this.confirmShipPassingRequest.PassingDate === "" || this.confirmShipPassingRequest.PassingDate === undefined || this.confirmShipPassingRequest.PassingDate === null){
      else if(this.confirmShipPassingRequest.PassingDate === undefined || this.confirmShipPassingRequest.PassingDate === null){
        this.isPassingDateNotValid = true;
        isFormValid = false;
      }
    }
    if(isFormValid){
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.confirmShipPassingRequest.LongHaulRequestId = this.rebateRequestId;
      this.confirmShipPassingRequest.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
      if(this.confirmShipPassingRequest.IsShipPassed)
        this.confirmShipPassingRequest.TimeZoneOffset = this.confirmShipPassingRequest.PassingDate.getTimezoneOffset();
      this.submitConfirmShipPassing();
    }
  }
  submitConfirmShipPassing(): void {
    this.longHaulService.confirmShipPassing(this.confirmShipPassingRequest).subscribe(
      data => this.confirmShipPassingRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitConfirmShipPassingCompleted()
    );
  }
  submitConfirmShipPassingCompleted(): void {
    if(!this.confirmShipPassingRequestResponseObject.Success) {
      //Enable Error / Warning
      if(this.confirmShipPassingRequestResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.confirmShipPassingRequestResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    this.isRequestSucceeded = true;
  }
  checkLoadedComponents(): void {
    this.noOfLoadedComponents++;
    if(this.noOfLoadedComponents == this.noOfComponentsToLoad){
      this.setFormMode();
    }
  }
  setFormMode(): void {
    if(this.confirmShipPassingRequest.IsFormSubmitted){
      this.formMode = FormMode.Details;
      this.isOptionDetailsEnabled = true;
      this.selectedLongHaulRequestRequestorDecisionOption = this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision.filter(l => l.Id == this.confirmShipPassingRequest.LongHaulRequestOptionId)[0];
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({behavior:'smooth'});
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }
}

enum FormMode {
  New = 1,
  Details = 2
}

enum ConfirmationMode {
  Success  = 1,
  Warning = 2,
  Error = 3
}
